import { orderBy } from 'lodash';
import { useQuery } from 'react-query';
import { COVENANT_COMPARE_DETAILS_DATA_CACHE_KEY } from '../../Constants';
import { fetchCovenantCompareDetailsData } from '../../services/covenant-compare.service';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default (ids) => {
  // eslint-disable-next-line no-param-reassign
  ids = orderBy(ids);
  return useQuery<any, Error>([COVENANT_COMPARE_DETAILS_DATA_CACHE_KEY, ...ids], async () => fetchCovenantCompareDetailsData(ids));
};
